import React, { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const BlogPage = lazy(() => import('../pages/get-cash/page'));
const SellHouseFastElPasoPage = lazy(() => import('../pages/get-cash/sell-house-fast-el-paso/page'));
const AvoidingForeclosurePage = lazy(() => import('../pages/get-cash/avoiding-foreclosure-options/page'));
const InheritHouseTexasPage = lazy(() => import('../pages/get-cash/inherit-house-texas/page'));
const SellHouseCodeViolationsPage = lazy(() => import('../pages/get-cash/sell-house-code-violations-el-paso/page'));
const SellHouseAsIsElPasoPage = lazy(() => import('../pages/get-cash/sell-house-as-is-el-paso/page'));
const SellHouseWithTenantsPage = lazy(() => import('../pages/get-cash/sell-house-with-tenants-el-paso/page'));
const WhyHouseNotSellingPage = lazy(() => import('../pages/get-cash/why-house-not-selling-el-paso/page'));
const FailedFHAVAInspectionPage = lazy(() => import('../pages/get-cash/failed-fha-va-inspection/page'));
const CantPayMortgagePage = lazy(() => import('../pages/get-cash/cant-pay-mortgage-el-paso/page'));
const GiveHouseBackToBankPage = lazy(() => import('../pages/get-cash/give-house-back-to-bank-el-paso/page'));
const HiddenCostsForeclosurePage = lazy(() => import('../pages/get-cash/hidden-costs-foreclosure-el-paso/page'));
const DeedInLieuVsCashSalePage = lazy(() => import('../pages/get-cash/deed-in-lieu-vs-cash-sale-el-paso/page'));
const SellingInheritedHouseProbateTexasPage = lazy(() => import('../pages/get-cash/selling-inherited-house-probate-texas/page'));
const FinancingHouseElPasoTxPage = lazy(() => import('../pages/get-cash/financing-house-el-paso-tx/page'));
const MarketDataElPasoTexasPage = lazy(() => import('../pages/get-cash/market-data-el-paso-texas/page'));
const ElPasoPropertyTaxRatesPage = lazy(() => import('../pages/get-cash/el-paso-property-tax-rates/page'));
const ElPasoHomeownerInsuranceCostsPage = lazy(() => import('../pages/get-cash/el-paso-homeowner-insurance-costs/page'));
const ElPasoClosingCostsSellerFeesPage = lazy(() => import('../pages/get-cash/el-paso-closing-costs-seller-fees/page'));
const ElPasoHomeSellingTimelinePage = lazy(() => import('../pages/get-cash/el-paso-home-selling-timeline/page'));
const ElPasoNeighborhoodGuideSellersPage = lazy(() => import('../pages/get-cash/el-paso-neighborhood-guide-sellers/page'));
const SellHouseDivorceElPasoPage = lazy(() => import('../pages/get-cash/sell-house-divorce-el-paso/page'));
const FireDamagedPropertyElPasoPage = lazy(() => import('../pages/get-cash/fire-damaged-property-el-paso/page'));
const HowToFindInvestorPage = lazy(() => import('../pages/quick-sale/how-to-find-an-investor-to-buy-my-house/page'));
const CashSaleQuickClosePage = lazy(() => import('../pages/quick-sale/cash-sale-quick-close/page'));
const QuickSaleCategoryPage = lazy(() => import('../pages/quick-sale/page'));
const SellHouseAnimalHoardingPage = lazy(() => import('../pages/quick-sale/sell-house-with-previous-animal-hoarding/page'));

const fallback = <div>Loading…</div>;

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={fallback}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash',
    element: (
      <Suspense fallback={fallback}>
        <BlogPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/sell-house-fast-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <SellHouseFastElPasoPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/avoiding-foreclosure-options',
    element: (
      <Suspense fallback={fallback}>
        <AvoidingForeclosurePage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/inherit-house-texas',
    element: (
      <Suspense fallback={fallback}>
        <InheritHouseTexasPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/sell-house-code-violations-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <SellHouseCodeViolationsPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/sell-house-as-is-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <SellHouseAsIsElPasoPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/sell-house-with-tenants-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <SellHouseWithTenantsPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/why-house-not-selling-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <WhyHouseNotSellingPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/failed-fha-va-inspection',
    element: (
      <Suspense fallback={fallback}>
        <FailedFHAVAInspectionPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/cant-pay-mortgage-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <CantPayMortgagePage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/give-house-back-to-bank-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <GiveHouseBackToBankPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/hidden-costs-foreclosure-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <HiddenCostsForeclosurePage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/deed-in-lieu-vs-cash-sale-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <DeedInLieuVsCashSalePage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/selling-inherited-house-probate-texas',
    element: (
      <Suspense fallback={fallback}>
        <SellingInheritedHouseProbateTexasPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/financing-house-el-paso-tx',
    element: (
      <Suspense fallback={fallback}>
        <FinancingHouseElPasoTxPage />
      </Suspense>
    ),
  },
  {
    path: '/market-data-el-paso-texas',
    element: (
      <Suspense fallback={fallback}>
        <MarketDataElPasoTexasPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/el-paso-property-tax-rates',
    element: (
      <Suspense fallback={fallback}>
        <ElPasoPropertyTaxRatesPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/el-paso-homeowner-insurance-costs',
    element: (
      <Suspense fallback={fallback}>
        <ElPasoHomeownerInsuranceCostsPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/el-paso-closing-costs-seller-fees',
    element: (
      <Suspense fallback={fallback}>
        <ElPasoClosingCostsSellerFeesPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/el-paso-home-selling-timeline',
    element: (
      <Suspense fallback={fallback}>
        <ElPasoHomeSellingTimelinePage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/el-paso-neighborhood-guide-sellers',
    element: (
      <Suspense fallback={fallback}>
        <ElPasoNeighborhoodGuideSellersPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/sell-house-divorce-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <SellHouseDivorceElPasoPage />
      </Suspense>
    ),
  },
  {
    path: '/get-cash/fire-damaged-property-el-paso',
    element: (
      <Suspense fallback={fallback}>
        <FireDamagedPropertyElPasoPage />
      </Suspense>
    ),
  },
  {
    path: '/quick-sale',
    element: (
      <Suspense fallback={fallback}>
        <QuickSaleCategoryPage />
      </Suspense>
    ),
  },
  {
    path: '/quick-sale/how-to-find-an-investor-to-buy-my-house',
    element: <HowToFindInvestorPage />,
  },
  {
    path: '/quick-sale/cash-sale-quick-close',
    element: <CashSaleQuickClosePage />,
  },
  {
    path: '/quick-sale/sell-house-with-previous-animal-hoarding',
    element: (
      <Suspense fallback={fallback}>
        <SellHouseAnimalHoardingPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={fallback}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
